<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">单词语音设置</div>
      
      <el-form-item label="app_id">
        <el-input v-model="form.app_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="api_key">
        <el-input v-model="form.api_key" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="secret_key">
        <el-input v-model="form.secret_key" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>


  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          app_id: '',
          api_key: '',
          secret_key: '',
        },
        w7:{},
        loading: false,
      };
    },
    created() {
      this.getData()
    },

    methods: {
      getData() {
        let self = this;
        SettingApi.wordDetail({}, true)
          .then(data => {
            let vars = data.data.vars.values;
            self.form.app_id = vars.engine.baiduyun.app_id;
            self.form.api_key = vars.engine.baiduyun.api_key;
            self.form.secret_key = vars.engine.baiduyun.secret_key;
            self.w7 = data.data.w7;
          })
          .catch(error => {});

      },
      //提交表单
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        SettingApi.editWord(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，单词语音设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },
      //发送短信
      sendOut() {
        let self = this;
        let params = this.form;
        SettingApi.sendSms(params, true)
          .then(data => {
            self.$message({
              message: '恭喜你，短信发送成功',
              type: 'success'
            });
            self.$router.push('/setting/Sms');

          })
          .catch(error => {

          });
      }



    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/word/index.vue